import { jsx } from "react/jsx-runtime";
const BREAKPOINTS = {
  xs: 0,
  sm: 321,
  md: 481,
  lg: 769,
  xl: 1024,
  xxl: 1281
};
const mediaBreakpointHelper = (breakpoints, breakpoint) => {
  const split = breakpoint.split("_");
  const shirtSize = split[0];
  const strategy = split[1] || "gte";
  if (!breakpoints) {
    return "all";
  }
  const keys = Object.keys(breakpoints);
  const value = breakpoints[shirtSize];
  const index = keys.indexOf(shirtSize);
  if (index < 0) {
    throw new Error(`The breakpoint size '${shirtSize}' does not exist on the theme. Use one of ${keys.map((k) => `'${k}'`).join(", ")}.`);
  }
  if (["lte", "eq", "gte"].indexOf(strategy) < 0) {
    throw new Error(`The strategy '${strategy}' is not valid for breakpoint '${breakpoint}'. Use one of '${shirtSize}_lte', '${shirtSize}_eq', '${shirtSize}_gte'.`);
  }
  let min = "";
  if (strategy !== "lte") {
    min = `(min-width: ${value}px)`;
  }
  let max = "";
  if (strategy !== "gte" && index < keys.length - 1) {
    max = `(max-width: ${breakpoints[keys[index + 1]] - 1}px)`;
  }
  if (min || max) {
    return `${min}${min && max ? " and " : ""}${max}`;
  }
  return "all";
};
const Source = ({
  media,
  ...rest
}) => {
  return /* @__PURE__ */ jsx("source", { ...rest, media: media ? mediaBreakpointHelper(BREAKPOINTS, media) : void 0 });
};
export {
  BREAKPOINTS,
  Source as default,
  mediaBreakpointHelper
};
